/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrendingTimesIds } from './TrendingTimesIds';
import {
    TrendingTimesIdsFromJSON,
    TrendingTimesIdsFromJSONTyped,
    TrendingTimesIdsToJSON,
} from './TrendingTimesIds';

/**
 * 
 * @export
 * @interface TrendingIdsResponse
 */
export interface TrendingIdsResponse {
    /**
     * 
     * @type {TrendingTimesIds}
     * @memberof TrendingIdsResponse
     */
    data?: TrendingTimesIds;
}

/**
 * Check if a given object implements the TrendingIdsResponse interface.
 */
export function instanceOfTrendingIdsResponse(value: object): value is TrendingIdsResponse {
    let isInstance = true;

    return isInstance;
}

export function TrendingIdsResponseFromJSON(json: any): TrendingIdsResponse {
    return TrendingIdsResponseFromJSONTyped(json, false);
}

export function TrendingIdsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrendingIdsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : TrendingTimesIdsFromJSON(json['data']),
    };
}

export function TrendingIdsResponseToJSON(value?: TrendingIdsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': TrendingTimesIdsToJSON(value.data),
    };
}

